/**
 * Component: Cookie Banner
 * ------------------------------------------------------------------------------
 * Simple component to remove a container on click and disable using cookies.
 *
 * @namespace cookieBanner
 */
import Cookies from 'js-cookie';
import cssClasses from '~/helpers/cssClasses';
import { extendDefaults, on } from '~/helpers/utils';
/**
 * DOM selectors.
 */

const selectors = {
  container: '[js-cookie-banner="container"]',
  close: '[js-cookie-banner="close"]'
};
/**
 * Create a new notification object.
 * @param {Object} config - Configuration.
 */

export default (config => {
  /**
   * Instance default settings.
   */
  const defaults = {
    cookie: {
      namespace: 'cookie-policy',
      value: 'accepted',
      expiry: 7
    }
  };
  /**
   * Instance settings.
   */

  const settings = extendDefaults(defaults, config);
  /**
   * DOM node selectors.
   */

  const nodeSelectors = {
    container: document.querySelector(selectors.container)
  };
  /**
   * Initialize component.
   */

  function init() {
    if (!nodeSelectors.container) {
      return;
    }

    if (Cookies.get(settings.cookie.namespace) === settings.cookie.value) {
      setTimeout(() => handleChatWidgets(), 3000);
      return;
    }

    setInitState();
    setEventListeners();
  }
  /**
   * Set event listeners.
   */


  function setEventListeners() {
    on('click', nodeSelectors.container.querySelector(selectors.close), event => handleCloseEvent(event));
  }
  /**
   * Set init state.
   */


  function setInitState() {
    nodeSelectors.container.classList.add(cssClasses.active);
  }
  /**
   * Handle close event.
   * @param {Event} event - Click event.
   */


  function handleCloseEvent(event) {
    event.preventDefault();
    nodeSelectors.container.classList.remove(cssClasses.active);
    Frame.EventBus.emit('Cookie:accepted');
    Cookies.set(settings.cookie.namespace, settings.cookie.value, {
      expires: settings.cookie.expiry
    });
    handleChatWidgets();
  }
  /**
   * Position chat widgets on load or cookie banner close.
   */


  function handleChatWidgets() {
    const beaconChat = document.querySelector('#beacon-container');
    const shopifyChat = document.querySelector('#ShopifyChat');

    if (beaconChat) {
      beaconChat.classList.add('cookies-accepted');
    }

    if (shopifyChat) {
      shopifyChat.classList.add('cookies-accepted');
    }
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init
  });
});